
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"9.5","cy":"9.5","r":"1.5","fill":"#949AA1"}}),_c('circle',{attrs:{"cx":"15.5","cy":"9.5","r":"1.5","fill":"#949AA1"}}),_c('circle',{attrs:{"cx":"9.5","cy":"15.5","r":"1.5","fill":"#949AA1"}}),_c('circle',{attrs:{"cx":"15.5","cy":"15.5","r":"1.5","fill":"#949AA1"}})])
          )
        }
      }
    